// @flow

import { defineMessages } from 'react-intl';

export const interiorPhotoMessages = defineMessages({
    titleFull: {
        id: 'abt.interiorsPhoto.pageTitle.full',
        defaultMessage: '{photoName} by {firmName} on',
    },
    titleNoFirm: {
        id: 'abt.interiorsPhoto.pageTitle.noFirm',
        defaultMessage: '{photoName} on',
    },
    titleEmpty: {
        id: 'abt.interiorsPhoto.pageTitle.empty',
        defaultMessage: 'Interior Design Photo on',
    },
    projectNameEmpty: {
        id: 'abt.interiorsPhoto.pageDescription.empty',
        defaultMessage: 'Interior Design Project on',
    },
});
